import { Controller } from 'stimulus';

class MapOverlayController extends Controller {
  onOpenClick() {
    this.overlayTarget.classList.add('is-open');
    document.querySelector('body').classList.add('overflow-y-hidden');
  }

  onCloseClick() {
    this.overlayTarget.classList.remove('is-open');
    document.querySelector('body').classList.remove('overflow-y-hidden');
  }
}

MapOverlayController.targets = [
  'overlay',
];

export default MapOverlayController;
